import gql from "graphql-tag"

export const IncidentDocumentQuery = gql`
    query IncidentDocument($id: ID!) {
        incidentDocument(id: $id) {
            id
            pk
            notes
            url
            document
            slug
            isArchived
            dateAdded
            documentType {
                id
                name
            }
            createdBy {
                id
                username
            }
        }
    }
`

export const ExtractIncidentDocumentDataMutation = gql`
    mutation ExtractIncidentDocumentData($input: ExtractIncidentDocumentDataMutationInput!) {
        extractIncidentDocumentData(input: $input) {
            ok
            text
            entities
            structuredOutput
            errors {
                field
                messages
            }
        }
    }
`

export const UpdateIncidentDocumentMutation = gql`
    mutation UpdateIncidentDocument($input: UpdateIncidentDocumentMutationInput!) {
        updateIncidentDocument(input: $input) {
            ok
            errors {
                field
                messages
            }
        }
    }
`

export const IncidentDocumentTypesQuery = gql`
    query IncidentDocumentTypesForCategory($category: String!) {
        allIncidentDocumentTypes(category: $category, isActive: true) {
            edges {
                node {
                    id
                    name
                }
            }
        }
    }
`
